"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect, useState } from "react";
import { motion, useInView } from "framer-motion";
interface FadeContentProps {
  children: React.ReactNode;
  blur?: boolean;
  duration?: number;
  easing?: any;
  threshold?: number;
  initialOpacity?: number;
  className?: string;
}
export default function FadeContent(t0) {
  const $ = _c(18);
  const {
    children,
    blur: t1,
    duration: t2,
    easing: t3,
    threshold: t4,
    initialOpacity: t5,
    className: t6
  } = t0;
  const blur = t1 === undefined ? false : t1;
  const duration = t2 === undefined ? 0.8 : t2;
  const easing = t3 === undefined ? "easeOut" : t3;
  const threshold = t4 === undefined ? 0.1 : t4;
  const initialOpacity = t5 === undefined ? 0 : t5;
  const className = t6 === undefined ? "" : t6;
  const ref = useRef(null);
  let t7;
  if ($[0] !== threshold) {
    t7 = {
      once: true,
      amount: threshold
    };
    $[0] = threshold;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const isInView = useInView(ref, t7);
  const t8 = blur ? "blur(10px)" : "none";
  let t9;
  if ($[2] !== initialOpacity || $[3] !== t8) {
    t9 = {
      opacity: initialOpacity,
      filter: t8,
      y: 20
    };
    $[2] = initialOpacity;
    $[3] = t8;
    $[4] = t9;
  } else {
    t9 = $[4];
  }
  let t10;
  if ($[5] !== blur || $[6] !== initialOpacity || $[7] !== isInView) {
    t10 = isInView ? {
      opacity: 1,
      filter: "blur(0px)",
      y: 0
    } : {
      opacity: initialOpacity,
      filter: blur ? "blur(10px)" : "none",
      y: 20
    };
    $[5] = blur;
    $[6] = initialOpacity;
    $[7] = isInView;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== duration || $[10] !== easing) {
    t11 = {
      duration,
      ease: easing
    };
    $[9] = duration;
    $[10] = easing;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== children || $[13] !== className || $[14] !== t10 || $[15] !== t11 || $[16] !== t9) {
    t12 = <motion.div ref={ref} initial={t9} animate={t10} transition={t11} className={className}>{children}</motion.div>;
    $[12] = children;
    $[13] = className;
    $[14] = t10;
    $[15] = t11;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}